import request from '@/utils/request';

// 1. 查询商店交付应用列表
export function fetchDeliveryList(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/market/deliverapps',
    method: 'get',
    params
  });
}
// 交付应用详情
export function fetchDeliveryAppsInfo(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/market/deliverapps/' + params.deliverID,
    method: 'get'
  });
}

// 查询交付客户应用列表
export function fetchCustomerList(params) {
  return request({
    url: '/ajax/enterprises/' + params.ID + '/customers',
    method: 'get',
    params
  });
}
//删除交付用户
export function deleteCustomer(data) {
  return request({
    url: '/ajax/enterprises/' + data.EID + '/customers/'+data.customerID,
    method: 'post',
    data: data
  });
}

// 添加交付客户应用列表
export function addCustomerDeliveryUser(data) {
  return request({
    url: '/ajax/enterprises/' + data.ID + '/customers',
    method: 'post',
    data: data
  });
}
// 修改交付操作
export function operationDeliveryApps(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/market/deliverapps/' + params.deliverID + '/' + params.action,
    method: 'post'
  });
}
export function fetchDeliveryAppStatus(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/delivers/' + params.order_id + '/status',
    method: 'get',
    params
  });
}

export function fetchDeliveryAppDomain(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/delivers/' + params.order_id + '/domain',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/delivery.js